import { render, staticRenderFns } from "./myPublishedHomework.vue?vue&type=template&id=283c458c&scoped=true"
import script from "./myPublishedHomework.vue?vue&type=script&lang=js"
export * from "./myPublishedHomework.vue?vue&type=script&lang=js"
import style0 from "./myPublishedHomework.vue?vue&type=style&index=0&id=283c458c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283c458c",
  null
  
)

export default component.exports